const themes = {
    admin: {
        navColor: "#1F618D",
        navDropDown: "#A8BFCF",
        navDropdownItems: "#7CA9CB",
    },
    companyManager: {
        navColor: "#1f6122",
        navDropDown: "#33bf22",
        navDropdownItems: "#33a922",
    },
    manager: {
        navColor: "#1F618D",
        navDropDown: "#A8BFCF",
        navDropdownItems: "#7CA9CB",
    },
    head: {
        navColor: "#1F618D",
        navDropDown: "#A8BFCF",
        navDropdownItems: "#7CA9CB",
    },
    researcher: {
        navColor: "#8E44AD",
        navDropDown: "#d7bde2",
        navDropdownItems: "#c39bd3",
    },
    referee: {
        navColor: "#117864",
        navDropDown: "#C8E2CA",
        navDropdownItems: "#B1DAB5",
    },
    university: {
        navColor: "#117864",
        navDropDown: "#C8E2CA",
        navDropdownItems: "#B1DAB5",
    },
    company: {
        navColor: "#3A82B5",
        navDropDown: "#C8E2CA",
        navDropdownItems: "#B1DAB5",
    },
    accelerator: {
        navColor: "#FF8A65",
        navDropDown: "#C8E2CA",
        navDropdownItems: "#B1DAB5",
    },
};

export const ThemingService = {
    changeTheme(themeVal) {
        if (themeVal) this.setTheme(themes[themeVal]);
        else this.setTheme(themes.researcher);
    },
    setTheme(themeVal) {
        Object.keys(themeVal).forEach((k) =>
            document.documentElement.style.setProperty(`--${k}`, themeVal[k])
        );
    },
};